import { HttpEventType, HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProcesoService } from 'src/app/pages/configuraciones/services/proceso.service';
import Swal from 'sweetalert2';
import { GenericFilterPlanes, SelectOptionResponse } from '../models/generic-entities.model';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { ClienteService } from 'src/app/pages/configuraciones/services/cliente.service';
import { ProyectoService } from 'src/app/pages/configuraciones/services/proyecto.service';
import { SedeService } from 'src/app/pages/configuraciones/services/sede.service';
import { SubProcesoService } from 'src/app/pages/configuraciones/services/subproceso.service';

@Component({
  selector: 'app-filtro-generico-planes',
  templateUrl: './filtro-generico-planes.component.html',
  styleUrls: ['./filtro-generico-planes.component.scss']
})
export class FiltroGenericoPlanesComponent implements OnInit {

  constructor(private formBuilder: UntypedFormBuilder, public modalService: NgbModal,
    private clienteService: ClienteService,
    private proyectoService: ProyectoService,
    private sedeService: SedeService,
    private procesoService: ProcesoService,
    private subProcesoService: SubProcesoService,
    public authService: AuthenticationService
  ) { }

  filterForm!: UntypedFormGroup;
  submit!: boolean;
  formsubmit!: boolean;
  clientes: SelectOptionResponse[] = [];
  sedes: SelectOptionResponse[] = [];
  proyectos: SelectOptionResponse[] = [];
  procesos: SelectOptionResponse[] = [];
  subProcesos: SelectOptionResponse[] = [];

  filtro!: GenericFilterPlanes;

  @Output() onFilterFinish: EventEmitter<GenericFilterPlanes> = new EventEmitter();
  @Output() onFilterAll: EventEmitter<boolean> = new EventEmitter();
  @Output() onExportar: EventEmitter<boolean> = new EventEmitter();

  ngOnInit() {
    this.filterForm = this.formBuilder.group({
      proceso: ['0'],
      subProceso: ['0'],
      cliente: ['0'],
      proyecto: ['0'],
      sede: ['0']
    });

    this.getProcesosData();

    this.getClienteData();

  }

  getProcesosData() {
    this.procesoService.getSelectOption().subscribe({
      next: (event) => {
        if (event.type === HttpEventType.Response && event.body) {
          this.procesos = event.body;
        }
      },
      error: (err: HttpErrorResponse) => {
        console.error(err.error)
      },
    });
  }

  getSubProcesosData(subProcesoId: string) {
    this.subProcesoService.getSelectSubproceso(subProcesoId).subscribe({
      next: (event) => {
        if (event.type === HttpEventType.Response && event.body) {
          this.subProcesos = event.body;
        }
      },
      error: (err: HttpErrorResponse) => {
        console.error(err.error);
      },
    });
  }

  validateSelection(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (value === '0') {
      return { notSelected: true };
    }
    return null;
  }

  async getClienteData(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.clienteService.getSelectOption().subscribe({
        next: (event) => {
          if (event.type === HttpEventType.Response && event.body) {
            this.clientes = event.body;
            this.proyectos = [];
            resolve();
          }
        },
        error: (err: HttpErrorResponse) => {
          console.error(err.error);
          reject(err);
        },
      });
    });
  }

  async getProyectoData(clienteId: string): Promise<void> {
    return new Promise((resolve, reject) => {
      this.proyectoService.getAllSelectOption(clienteId).subscribe({
        next: (event) => {
          if (event.type === HttpEventType.Response && event.body) {
            this.proyectos = event.body;
            this.sedes = [];
            resolve();
          }
        },
        error: (err: HttpErrorResponse) => {
          console.error(err.error);
          reject(err);
        },
      });
    });
  }

  onProcesoChange(event: Event) {
    const selectElement = event.target as HTMLSelectElement;
    if (selectElement.value != '0')
      this.getSubProcesosData(this.filterForm.controls['proceso'].value);
    else
      this.filterForm.controls['proceso'].setValue('0');

    // resetear los filtros de subproceso, cliente, proyecto y sede
    this.filterForm.controls['subProceso'].setValue('0');
    this.filterForm.controls['cliente'].setValue('0');
    this.filterForm.controls['proyecto'].setValue('0');
    this.filterForm.controls['sede'].setValue('0');
  }

  onSubProcesoChange(event: Event) {
    const selectElement = event.target as HTMLSelectElement;
    if (selectElement.value != '0')
      this.filterForm.controls['subProceso'].setValue(selectElement.value);
    else
      this.filterForm.controls['subProceso'].setValue('0');

    // resetear los filtros de cliente, proyecto y sede
    this.filterForm.controls['cliente'].setValue('0');
    this.filterForm.controls['proyecto'].setValue('0');
    this.filterForm.controls['sede'].setValue('0');
  }

  onClienteChange(event: Event) {
    const selectElement = event.target as HTMLSelectElement;
    if (selectElement.value != '0')
      this.getProyectoData(this.filterForm.controls['cliente'].value);
    else
      this.filterForm.controls['cliente'].setValue('0');

    // resetear los filtros de proyecto y sede
    this.filterForm.controls['proyecto'].setValue('0');
    this.filterForm.controls['sede'].setValue('0');
  }

  onProyectoChange(event: Event) {
    const selectElement = event.target as HTMLSelectElement;
    if (selectElement.value != '0')
      this.getSedesData(this.filterForm.controls['proyecto'].value);
    else
      this.filterForm.controls['proyecto'].setValue('0');

    // resetear el filtro de sede
    this.filterForm.controls['sede'].setValue('0');
  }

  onSedeChange(event: Event) {
    const selectElement = event.target as HTMLSelectElement;
    if (selectElement.value === '0')
      this.filterForm.controls['sede'].setValue('0');
  }

  getSedesData(proyectoId: string) {
    this.sedeService.getAllSelectOption([proyectoId]).subscribe({
      next: (event) => {
        if (event.type === HttpEventType.Response && event.body) {
          this.sedes = event.body;
        }
      },
      error: (err: HttpErrorResponse) => {
        console.error(err.error);
      },
    });
  }

  submitForm() {

    // validar que al menos un filtro tenga un valor diferente de '0'
    const hasValue = Object.values(this.filterForm.controls).some(control => control.value !== '0');
    if (!hasValue) {
      Swal.fire({
        title: "Alerta",
        text: "Debe seleccionar al menos un filtro",
        icon: "warning",
        confirmButtonColor: "rgb(3, 142, 220)",
        confirmButtonText: "Ok",
      });
      return;
    }

    this.submit = true;
    if (this.filterForm.valid) {

      this.filtro = {
        procesoId: this.filterForm.controls['proceso'].value === '0' ? '' : this.filterForm.controls['proceso'].value,
        subProcesoId: this.filterForm.controls['subProceso'].value === '0' ? '' : this.filterForm.controls['subProceso'].value,
        clienteId: this.filterForm.controls['cliente'].value === '0' ? '' : this.filterForm.controls['cliente'].value,
        proyectoId: this.filterForm.controls['proyecto'].value === '0' ? '' : this.filterForm.controls['proyecto'].value,
        sedeId: this.filterForm.controls['sede'].value === '0' ? '' : this.filterForm.controls['sede'].value,
      };

      this.onFilterFinish.emit(this.filtro);

    } else {
      this.filterForm.markAllAsTouched();
      Swal.fire({
        title: "Alerta",
        text: "Revisa la información de los campos del formulario",
        icon: "warning",
        confirmButtonColor: "rgb(3, 142, 220)",
        confirmButtonText: "Ok",
      });
      return;
    }
  }

  get form() {
    return this.filterForm.controls;
  }

  filtrarTodos() {
    this.onFilterAll.emit(true);
  }

  exportar() {
    this.onExportar.emit(true);
  }

}
